import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import "./styles.scss";
import { mobile, mobileM, tablet } from "../../responsive";
//
//
const ContainerRows = styled.div`
  width: 100%;
  padding: 0 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;
const Rows = styled.div`
  display: flex;

  width: 90%;
  margin: 0 0 0 0;
  padding: 100px 0 10px 0;

  ${mobile({ flexDirection: "column" })}
  ${mobileM({ flexDirection: "column" })}
      ${tablet({ flexDirection: "column" })};
`;
//
//
//
const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  ${mobile({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
    padding: "20px 0 60px 0",
  })}
  ${mobileM({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
    padding: "20px 0",
  })}
  ${tablet({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
    padding: "20px 0",
  })}
`;
//
const Logo = styled.h1`
  width: calc(10px + 1.3vmin);
  height: calc(10px + 1.3vmin);
  background-color: rgb(14, 14, 14);
  border-radius: 100%;
  ${mobile({ display: "none" })}
  ${mobileM({ display: "none" })}
    ${tablet({
    display: "none",
  })};
`;

//

const Center = styled.div`
  flex: 1;
  padding: 20px;

  ${mobile({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
  })}
  ${mobileM({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
  })}
      ${tablet({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
  })};
`;

const Title = styled.h3`
  margin-bottom: 30px;
  font-weight: 500;

  ${mobile({
    fontSize: "calc(14px + 1.4vmin)",
    marginBottom: "50px",
  })}
  ${mobileM({
    marginBottom: "50px",
  })}
      ${tablet({
    marginBottom: "50px",
  })};
`;
const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  color: "#ff1f1fcf";
`;

const ListItemFooter = styled.li`
  width: 50%;
  margin-bottom: 10px;

  text-transform: capitalize;
  font-size: calc(7px + 1vmin);
  ${mobile({
    fontSize: "calc(8px + 1.4vmin)",
    color: "#0f0f0fcf",
  })}
  ${mobileM({ fontSize: "calc(8px + 1.4vmin)" })}
  ${tablet({ fontSize: "calc(8px + 1.4vmin)" })} //
  /* ${mobile({
    fontSize: "1.2em",
    color: "#87411249",
    fontWeight: "500",
  })} */

  //
`;

const Right = styled.div`
  flex: 1;
  padding: 20px;
  ${mobile({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
  })}
  ${mobileM({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
  })}
  ${tablet({
    display: "flex",
    flexDirection: "column",
    justifContent: "center",
    alignItems: "center",
  })}
`;

/*






*/
const Desc = styled.div`
  color: #0f0f0fcf;
  font-size: calc(7px + 1vmin);

  font-weight: 300;
  margin-bottom: 40px;
  ${mobile({
    textAlign: "left",
    fontSize: "calc(8px + 1.4vmin)",
    lineHeight: "20px",
    margin: "0 0 40px 0",
  })}
  ${mobileM({
    textAlign: "center",
    fontSize: "calc(8px + 1.4vmin)",
    lineHeight: "calc(17px + 1.4vmin)",
    margin: "0 0 40px 0",
  })}
  ${tablet({
    textAlign: "left",
    fontSize: "calc(8px + 1.4vmin)",
    lineHeight: "20px",
    margin: "0 0 40px 0",
  })}
`;
//
const InputContainer = styled.div`
  height: 40px;

  border: 0 none;
  display: flex;
  justify-content: space-between;

  ${mobile({ width: "100%" })}
  ${mobileM({ width: "80%" })}
  ${tablet({ width: "80%" })}
`;
const Input = styled.input`
  border: 0 none;
  flex: 8;
  padding: 10px;
  background-color: #f3f3f367;

  ::placeholder {
    color: #0f0f0f5e;
    opacity: 1; /* Firefox */
  }
  &:focus {
    outline: none;
    background-color: #f3f3f3ca;
    color: #0f0f0ff8;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #0f0f0f5e;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #0f0f0f5e;
  }
  ${mobile({ width: "80%" })}
  ${mobileM({ width: "80%" })}
  ${tablet({ width: "80%" })}
`;
const Button = styled.button`
  flex: 1;
  border: 0;
  text-transform: uppercase;
  background-color: #f0f0f08f;
  padding: 10px 8px;
  color: #0f0f0f5e;
  transition: background-color 1s ease-in-out;
  &:hover {
    background-color: #e4e4e48f;
    color: #0f0f0f8f;
  }
`;
//
//

const Footer = () => {
  return (
    <>
      <ContainerRows>
        <Rows>
          <Left>
            <Logo></Logo>
          </Left>

          <Center>
            <Title>ABOUT US</Title>
            <List>
              <ListItemFooter>
                <Link to="/about" className="footer-Links">
                  About
                </Link>
              </ListItemFooter>
              <ListItemFooter>
                {" "}
                <Link to="/about" className="footer-Links">
                  Credits
                </Link>
              </ListItemFooter>
              <ListItemFooter>
                {" "}
                <Link to="/about" className="footer-Links">
                  My Account
                </Link>
              </ListItemFooter>
              <ListItemFooter>
                {" "}
                <Link to="/about" className="footer-Links">
                  Wishlist
                </Link>
              </ListItemFooter>
              <ListItemFooter>
                {" "}
                <Link to="/about" className="footer-Links">
                  Order
                </Link>
              </ListItemFooter>
              <ListItemFooter>
                {" "}
                <Link to="/about" className="footer-Links">
                  Term
                </Link>
              </ListItemFooter>
            </List>
          </Center>

          <Right>
            <Title>CONTACT</Title>

            <Desc>
              Follow us on the journey of creating beautiful objects for a
              better world.{" "}
            </Desc>

            <InputContainer>
              <Input placeholder="Your email" />
              <Button>Subscribe</Button>
            </InputContainer>
          </Right>
        </Rows>
      </ContainerRows>
    </>
  );
};

export default Footer;
